<!-- piezeo-sensor.component.html -->
<div class="dashboard-wrapper" [ngClass]="isDark ? 'dark-theme' : 'light-theme'">

  <header class="asset-info-header">
    <div class="info-items-container">
      <div class="info-item">
        <span class="info-value">
          <span *ngIf="loadingCompanyDetails" class="skeleton skeleton-text-device-details"
            style="display: inline-block; width: 100px; height: 18px;"></span>
          <span *ngIf="!loadingCompanyDetails">{{companyName}}</span>
        </span>
        <span class="info-label">CUSTOMER</span>
      </div>

      <div class="info-item">
        <span class="info-value">
          <span *ngIf="loadingCompanyDetails" class="skeleton skeleton-text-device-details"
            style="display: inline-block; width: 90px; height: 18px;"></span>
          <span *ngIf="!loadingCompanyDetails">{{siteName}}</span>
        </span>
        <span class="info-label">SITE</span>
      </div>

      <div class="info-item">
        <span class="info-value">
          <span *ngIf="loadingCompanyDetails" class="skeleton skeleton-text-device-details"
            style="display: inline-block; width: 110px; height: 18px;"></span>
          <span *ngIf="!loadingCompanyDetails">{{applicationName}}</span>
        </span>
        <span class="info-label">APPLICATION</span>
      </div>

      <div class="info-item">
        <span class="info-value">
          <span *ngIf="loadingCompanyDetails" class="skeleton skeleton-text-device-details"
            style="display: inline-block; width: 120px; height: 18px;"></span>
          <span *ngIf="!loadingCompanyDetails">{{serialNumber}}</span>
        </span>
        <span class="info-label">MACHINE SERIAL NUMBER</span>
      </div>

      <div class="info-item">
        <span class="info-value">
          <span *ngIf="loadingCompanyDetails" class="skeleton skeleton-text-device-details"
            style="display: inline-block; width: 100px; height: 18px;"></span>
          <span *ngIf="!loadingCompanyDetails">{{assetName}}</span>
        </span>
        <span class="info-label">ASSET NAME</span>
      </div>
    </div>
  </header>
  <main class="dashboard-content">
    <!-- Row 1 -->
    <div class="dashboard-row">
      <div class="dashboard-card" style="flex-grow: 12.5;">
        <div class="card-header card-header--split">
          <h2 class="card-title">Machine Vibration</h2>
          <div class="button-filter-container">
            <button *ngIf="!isAxisActive('X')" mat-stroked-button color="primary" (click)="onAxisChange('X')"
              [disabled]="loadingVibration || !availableAxis.includes('X')" class="custom-stroked">
              Radial
            </button>
            <button *ngIf="isAxisActive('X')" mat-raised-button color="primary" (click)="onAxisChange('X')"
              [disabled]="loadingVibration || !availableAxis.includes('X')">
              Radial
            </button>

            <button *ngIf="!isAxisActive('Y')" mat-stroked-button color="primary" (click)="onAxisChange('Y')"
              [disabled]="loadingVibration || !availableAxis.includes('Y')" class="custom-stroked">
              Tangential
            </button>
            <button *ngIf="isAxisActive('Y')" mat-raised-button color="primary" (click)="onAxisChange('Y')"
              [disabled]="loadingVibration || !availableAxis.includes('Y')">
              Tangential
            </button>

            <button *ngIf="!isAxisActive('Z')" mat-stroked-button color="primary" (click)="onAxisChange('Z')"
              [disabled]="loadingVibration || !availableAxis.includes('Z')" class="custom-stroked">
              Axial
            </button>
            <button *ngIf="isAxisActive('Z')" mat-raised-button color="primary" (click)="onAxisChange('Z')"
              [disabled]="loadingVibration || !availableAxis.includes('Z')">
              Axial
            </button>
          </div>
        </div>

        <div *ngIf="loadingVibration" class="gauge-grid">
          <div class="gauge-item" *ngFor="let i of [1,2,3]">
            <div class="skeleton skeleton-chart" style="width: 200px; height: 130px;"></div>
          </div>
        </div>

        <div *ngIf="!loadingVibration" class="gauge-grid">
          <div class="gauge-item" *ngFor="let gauge of axisVibrationGauge">
            <app-gauge-chart [canvasWidth]="200" [canvasHeight]="200" [needleValue]="gauge.value"
              [bottomLabel]="gauge.bottomLabel" [name]="gauge.name" [options]="gauge.options"
              [bottomLabelColor]="isDark ? '#f0f0f0' : '#18181b'"
              [nameColor]="gauge.isActive ? (isDark ? '#72FF13' : '#4caf50') : (isDark ? '#666' : '#999')"
              [arcLabelColor]="isDark ? '#f0f0f0' : '#18181b'" [rangeLabelColor]="isDark ? '#f0f0f0' : '#18181b'"
              [Piezo]="true" [class.gauge-active]="gauge.isActive" [class.gauge-inactive]="!gauge.isActive">
            </app-gauge-chart>
          </div>
        </div>
      </div>
      @if(!BHEL_ON_PREM){

      <div class="dashboard-card" style="flex-grow: 7;">
        <div class="card-header">
          <h2 class="card-title">Temperature</h2>
        </div>
        <div class="single-gauge">
          <div *ngIf="loadingTemperature" class="skeleton skeleton-chart" style="width: 200px; height: 130px;"></div>
          <app-gauge-chart *ngIf="!loadingTemperature" [canvasWidth]="200" [canvasHeight]="200"
            [needleValue]="temperature.value" [bottomLabel]="temperature.bottomLabel" [name]="temperature.name"
            [options]="temperature.options" [bottomLabelColor]="isDark ? '#f0f0f0' : '#18181b'"
            [nameColor]="(isDark ? '#72FF13' : '#4caf50')" [arcLabelColor]="isDark ? '#f0f0f0' : '#18181b'"
            [rangeLabelColor]="isDark ? '#f0f0f0' : '#18181b'" [Piezo]="true">
          </app-gauge-chart>
        </div>
      </div>
      }

      <div class="dashboard-card" style="flex-grow: 10;">
        <div class="card-header">
          <h2 class="card-title">Machine Health Status (12h)</h2>
        </div>

        <div class="chart-container">
          <!-- Skeleton while loading -->
          <div *ngIf="loadingBucket" class="skeleton skeleton-health-status" style="width: 800px;"></div>

          <!-- Chart after loading -->
          <apx-chart *ngIf="!loadingBucket" [series]="healthStatusOptions.series" [chart]="healthStatusOptions.chart"
            [plotOptions]="healthStatusOptions.plotOptions" [colors]="healthStatusOptions.colors"
            [dataLabels]="healthStatusOptions.dataLabels" [grid]="healthStatusOptions.grid"
            [tooltip]="healthStatusOptions.tooltip" [xaxis]="healthStatusOptions.xaxis"
            [yaxis]="healthStatusOptions.yaxis" [legend]="healthStatusOptions.legend" [fill]="healthStatusOptions.fill">
          </apx-chart>
        </div>
      </div>



    </div>

    <!-- Row 2 -->
    <div class="dashboard-row">
      <div class="dashboard-card">
        <div class="card-header">
          <h2 class="card-title">Operational Summary (24h)</h2>
        </div>
        <div class="card-content">
          <table class="data-table">
            <thead>
              <tr></tr>
            </thead>
            <tbody>
              <!-- Dynamic Data with Skeleton -->
              <tr>
                <td class="row-label">Number of Stops</td>
                <td class="data-cell text-green">
                  <span *ngIf="loadingOperationalSummary" class="skeleton skeleton-text-device-details"
                    style="display: inline-block; width: 40px; height: 16px;"></span>
                  <span *ngIf="!loadingOperationalSummary">{{noOfStops}}</span>
                </td>
              </tr>
              <tr>
                <td class="row-label">Machine Utilization</td>
                <td class="data-cell text-green">
                  <span *ngIf="loadingOperationalSummary" class="skeleton skeleton-text-device-details"
                    style="display: inline-block; width: 50px; height: 16px;"></span>
                  <span *ngIf="!loadingOperationalSummary">{{machineUtilization}} %</span>
                </td>
              </tr>
              <tr>
                <td class="row-label">Weekly Run Time</td>
                <td class="data-cell text-red">
                  <span *ngIf="loadingOperationalSummary" class="skeleton skeleton-text-device-details"
                    style="display: inline-block; width: 60px; height: 16px;"></span>
                  <span *ngIf="!loadingOperationalSummary">{{weeklyRunTime}}</span>
                </td>
              </tr>

              <!-- Static Data - Always Visible -->
              <!-- <tr>
                <td class="row-label text-green">In Service</td>
                <td class="data-cell">
                  <label class="switch">
                    <input type="checkbox" checked>
                    <span class="slider"></span>
                  </label>
                </td>
              </tr> -->
            </tbody>
          </table>
        </div>
      </div>
      <div class="dashboard-card">
        <div class="card-header">
          <h2 class="card-title">Anomaly Status</h2>
        </div>
        <div class="card-content">
          <table class="data-table">
            <tbody>
              <tr>
                <td class="row-label">Updated At</td>
                <td class="data-cell">
                  <span *ngIf="loadingAnomalyStatus" class="skeleton skeleton-text-device-details"
                    style="display: inline-block; width: 120px; height: 16px;"></span>
                  <span *ngIf="!loadingAnomalyStatus">{{lastUpdatedAt}}</span>
                </td>
              </tr>
              <tr>
                <td class="row-label">Status</td>
                <td class="data-cell">
                  <span *ngIf="loadingAnomalyStatus" class="skeleton skeleton-text-anomaly-status"
                    style="display: inline-block; width: 100px; height: 24px; border-radius: 12px;"></span>
                  <span *ngIf="!loadingAnomalyStatus" class="status-pill"
                    [ngClass]="anomalyActionClass">{{anomalyStatus}}</span>
                </td>
              </tr>
              <tr>
                <td class="row-label">Recommended Action</td>
                <td class="data-cell">
                  <span *ngIf="loadingAnomalyStatus" class="skeleton skeleton-text-recommended-action"
                    style="display: inline-block; width: 150px; height: 16px;"></span>
                  <span *ngIf="!loadingAnomalyStatus" [ngClass]="actionClass">{{recommendedAction}}</span>
                </td>
              </tr>
              <tr *ngIf="!BHEL_ON_PREM">
                <td class="row-label">Asset Report</td>
                <td class="data-cell">
                  <button mat-raised-button color="primary" (click)="openReportModal()">Generate Report</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="dashboard-card" style="flex-grow: 1;">
        <div class="card-header">
          <h2 class="card-title">Machine Alert Summary (24h)</h2>
        </div>
        <div class="card-content">
          <div class="table-container">
            <table class="data-table">
              <thead>
                <tr>
                  <th class="text-green">Category</th>
                  <th class="text-green">Details</th>
                  <th class="text-green">Timestamp</th>
                  <th class="text-green">Status</th>
                </tr>
              </thead>
              <tbody>
                <!-- Skeleton Rows while Loading -->
                <ng-container *ngIf="loadingAlerts">
                  <tr *ngFor="let i of [1,2,3]">
                    <td>
                      <span class="skeleton skeleton-text-device-details"
                        style="display: inline-block; width: 80px; height: 16px;"></span>
                    </td>
                    <td>
                      <span class="skeleton skeleton-text-device-details"
                        style="display: inline-block; width: 150px; height: 16px;"></span>
                    </td>
                    <td>
                      <span class="skeleton skeleton-text-device-details"
                        style="display: inline-block; width: 120px; height: 16px;"></span>
                    </td>
                    <td>
                      <span class="skeleton skeleton-text-device-details"
                        style="display: inline-block; width: 60px; height: 16px;"></span>
                    </td>
                  </tr>
                </ng-container>

                <!-- Actual Data Rows -->
                <ng-container *ngIf="!loadingAlerts">
                  <tr *ngFor="let alert of alerts">
                    <td class="clickable-category" (click)="OnClickAlert(alert)">
                      {{ alert.category || '—' }}
                    </td>

                    <td>
                      {{ BHEL_ON_PREM?"Vibration anomaly detected. Please review":alert.details || '-' }}
                    </td>

                    <td class="clickable-category" (click)="OnClickTimeStamp(alert)">
                      {{ alert.time || '—' }}
                    </td>

                    <td [ngClass]="alert.statusColor">
                      {{ alert.status || '—' }}
                    </td>
                  </tr>

                  <!-- WHEN ARRAY IS EMPTY -->
                  <tr *ngIf="alerts?.length === 0">
                    <td colspan="4" class="text-center text-orange">
                      No alerts found in the last 24 hours
                    </td>
                  </tr>
                </ng-container>

              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="dashboard-card">
        <div class="card-header card-header--split">
          <h2 class="card-title">Service Planner</h2>
          <!-- <button mat-stroked-button color="primary" class="custom-stroked">Update</button> -->
          <ng-container>
            <button mat-menu-item (click)="openServiceModal()" style="border: none; background-color: transparent">
              <mat-icon class="text-secondary">settings</mat-icon>
              <!-- <span>Settings</span> -->
            </button>
          </ng-container>
        </div>
        <div class="card-content">
          <table class="data-table">
            <tbody>
              <tr>
                <td class="row-label">Last Service Date</td>
                <td class="data-cell text-green">
                  <span *ngIf="loadingServiceData" class="skeleton skeleton-text-device-details"
                    style="display: inline-block; width: 80px; height: 16px;"></span>
                  <span *ngIf="!loadingServiceData">{{lastServiceDate}}</span>
                </td>
              </tr>
              <tr>
                <td class="row-label">Service Performed</td>
                <td class="data-cell text-orange">
                  <span *ngIf="loadingServiceData" class="skeleton skeleton-text-device-details"
                    style="display: inline-block; width: 100px; height: 16px;"></span>
                  <span *ngIf="!loadingServiceData">{{servicePerformed}}</span>
                </td>
              </tr>
              <tr>
                <td class="row-label">Next Service Due</td>
                <td class="data-cell text-red">
                  <span *ngIf="loadingServiceData" class="skeleton skeleton-text-device-details"
                    style="display: inline-block; width: 80px; height: 16px;"></span>
                  <span *ngIf="!loadingServiceData">{{nextServiceDate}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="trends-chart-button-container">
      <button mat-raised-button color="accent" class="trends-button" (click)="handleTrends()">
        <span>{{!showTrendsChart ? 'Show' : 'Hide'}} Trends</span>
        <mat-icon class="animated-icon">{{!showTrendsChart ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</mat-icon>
      </button>
    </div>
    @if (showTrendsChart) {
    <div class="filter-container">
      <div class="filter-buttons">
        <button *ngIf="selectedTimeFilter === 'hourly'" type="button" mat-raised-button color="primary">
          Hourly
        </button>
        <button *ngIf="selectedTimeFilter !== 'hourly'" type="button" mat-stroked-button color="primary"
          (click)="changeTimeFilter('hourly')">
          Hourly
        </button>
        <button *ngIf="selectedTimeFilter === 'daily'" type="button" mat-raised-button color="primary">
          Daily
        </button>
        <button *ngIf="selectedTimeFilter !== 'daily'" type="button" mat-stroked-button color="primary"
          (click)="changeTimeFilter('daily')">
          Daily
        </button>
        <button *ngIf="selectedTimeFilter === 'weekly'" type="button" mat-raised-button color="primary">
          Weekly
        </button>
        <button *ngIf="selectedTimeFilter !== 'weekly'" type="button" mat-stroked-button color="primary"
          (click)="changeTimeFilter('weekly')">
          Weekly
        </button>
      </div>
      <div class="filter-calendar">
        <mat-form-field appearance="outline">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate">
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate">
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>

        <button mat-raised-button color="accent" (click)="applyDateFilter()">
          Apply
        </button>
      </div>
    </div>
    <div class="dashboard-row">
      <div class="dashboard-card" style="flex: 1;">
        <div class="card-header">
          <h2 class="card-title">
            {{ getTrendChartTitle('velocity') }}
          </h2>
        </div>
        <div class="chart-container">
          <div *ngIf="trendsLoading.velocity" class="skeleton skeleton-trend-chart"></div>
          <div class="chart-wrapper" style="width: 100%;">
            <apx-chart *ngIf="!trendsLoading.velocity && trendsData.velocity" [series]="trendsData.velocity.series"
              [chart]="trendsData.velocity.chart" [colors]="trendsData.velocity.colors"
              [stroke]="trendsData.velocity.stroke" [markers]="trendsData.velocity.markers"
              [grid]="trendsData.velocity.grid" [xaxis]="trendsData.velocity.xaxis" [yaxis]="trendsData.velocity.yaxis"
              [tooltip]="trendsData.velocity.tooltip" [annotations]="trendsData.velocity.annotations"
              [legend]="trendsData.velocity.legend">
            </apx-chart>
          </div>
          <div *ngIf="!trendsLoading.velocity && !trendsData.velocity" class="no-data-message">
            No velocity data available
          </div>
        </div>
      </div>
    </div>
    <div class="dashboard-row">
      <div class="dashboard-card" style="flex: 1;">
        <div class="card-header">
          <h2 class="card-title">
            {{ getTrendChartTitle('acceleration') }}
          </h2>
        </div>
        <div class="chart-container">
          <div *ngIf="trendsLoading.acceleration" class="skeleton skeleton-trend-chart"></div>
          <div class="chart-wrapper" style="width: 100%;">
            <apx-chart *ngIf="!trendsLoading.acceleration && trendsData.acceleration"
              [series]="trendsData.acceleration.series" [chart]="trendsData.acceleration.chart"
              [colors]="trendsData.acceleration.colors" [stroke]="trendsData.acceleration.stroke"
              [markers]="trendsData.acceleration.markers" [grid]="trendsData.acceleration.grid"
              [xaxis]="trendsData.acceleration.xaxis" [yaxis]="trendsData.acceleration.yaxis"
              [tooltip]="trendsData.acceleration.tooltip" [annotations]="trendsData.acceleration.annotations"
              [legend]="trendsData.acceleration.legend">
            </apx-chart>
          </div>
          <div *ngIf="!trendsLoading.acceleration && !trendsData.acceleration" class="no-data-message">
            No acceleration data available
          </div>
        </div>
      </div>
    </div>
    <div class="dashboard-row">
      <div class="dashboard-card" style="flex: 1;">
        <div class="card-header">
          <h2 class="card-title">
            {{ getTrendChartTitle('displacement') }}
          </h2>
        </div>
        <div class="chart-container">
          <div *ngIf="trendsLoading.displacement" class="skeleton skeleton-trend-chart"></div>
          <div class="chart-wrapper" style="width: 100%;">
            <apx-chart *ngIf="!trendsLoading.displacement && trendsData.displacement"
              [series]="trendsData.displacement.series" [chart]="trendsData.displacement.chart"
              [colors]="trendsData.displacement.colors" [stroke]="trendsData.displacement.stroke"
              [markers]="trendsData.displacement.markers" [grid]="trendsData.displacement.grid"
              [xaxis]="trendsData.displacement.xaxis" [yaxis]="trendsData.displacement.yaxis"
              [tooltip]="trendsData.displacement.tooltip" [annotations]="trendsData.displacement.annotations"
              [legend]="trendsData.displacement.legend">
            </apx-chart>
          </div>
          <div *ngIf="!trendsLoading.displacement && !trendsData.displacement" class="no-data-message">
            No displacement data available
          </div>
        </div>
      </div>
    </div>
    @if(!BHEL_ON_PREM){
    <div class="dashboard-row" style="margin-bottom: 10rem;" *ngIf='data?.isTemperatureAdded == "1"'>
      <div class="dashboard-card" style="flex: 1;">
        <div class="card-header">
          <h2 class="card-title">
            {{ getTrendChartTitle('temperature') }}
          </h2>
        </div>
        <div class="chart-container">
          <div *ngIf="trendsLoading.temperature" class="skeleton skeleton-trend-chart"></div>
          <div class="chart-wrapper" style="width: 100%;">
            <apx-chart *ngIf="!trendsLoading.temperature && trendsData.temperature"
              [series]="trendsData.temperature.series" [chart]="trendsData.temperature.chart"
              [colors]="trendsData.temperature.colors" [stroke]="trendsData.temperature.stroke"
              [markers]="trendsData.temperature.markers" [grid]="trendsData.temperature.grid"
              [xaxis]="trendsData.temperature.xaxis" [yaxis]="trendsData.temperature.yaxis"
              [tooltip]="trendsData.temperature.tooltip" [annotations]="trendsData.temperature.annotations"
              [legend]="trendsData.temperature.legend">
            </apx-chart>
          </div>
          <div *ngIf="!trendsLoading.temperature && !trendsData.temperature" class="no-data-message">
            No temperature data available
          </div>
        </div>
      </div>
    </div>
    }
    }
  </main>
</div>


<!-- Modal for Report Generation -->
<div class="modal-backdrop fade show" *ngIf="isReportModalOpen"></div>

<div class="modal-overlay" *ngIf="isReportModalOpen" [@fadeInOut]>
  <div class="modern-modal" [@slideInOut]>
    <div class="modal-content">
      <div class="modal-header" [class.processing]="isLoading">
        <h4 class="modal-title">
          <span *ngIf="isLoading">{{ processingStepText }}</span>
          <span *ngIf="!isLoading">Report Ready</span>
        </h4>
        <button *ngIf="!isLoading" class="close-button" mat-icon-button (click)="closeReportModal()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="modal-body">
        <div *ngIf="isLoading" class="loading-container">
          <div class="progress-tracker">
            <div class="progress-bar" [style.width.%]="progressPercentage"></div>
          </div>
          <div class="animated-process-container">
            <div class="process-step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">
              <div class="step-icon-container">
                <div class="step-icon data-collection" [class.animate]="currentStep === 1">
                  <div class="data-point" *ngFor="let i of [1,2,3,4,5]"></div>
                  <div class="collector"></div>
                </div>
                <div class="step-check" *ngIf="currentStep > 1">
                  <mat-icon>check</mat-icon>
                </div>
              </div>
              <div class="step-details">
                <h6>Collecting Data</h6>
                <p *ngIf="currentStep === 1">Gathering piezo sensor metrics...</p>
                <p *ngIf="currentStep > 1">Data collection complete</p>
              </div>
            </div>

            <div class="process-step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2"
              [class.upcoming]="currentStep < 2">
              <div class="step-icon-container">
                <div class="step-icon sa-demand" [class.animate]="currentStep === 2">
                  <div class="sa-icon"></div>
                </div>
                <div class="step-check" *ngIf="currentStep > 2">
                  <mat-icon>check</mat-icon>
                </div>
              </div>
              <div class="step-details">
                <h6>Performing Report Generation</h6>
                <p *ngIf="currentStep === 2">Generating Report...</p>
                <p *ngIf="currentStep > 2">Report Generation Completed</p>
              </div>
            </div>

            <div class="process-step" [class.active]="currentStep === 3" [class.upcoming]="currentStep < 3">
              <div class="step-icon-container">
                <div class="step-icon finalizing" [class.animate]="currentStep === 3">
                  <div class="polish-effect"></div>
                </div>
              </div>
              <div class="step-details">
                <h6>Report Generated</h6>
                <p *ngIf="currentStep === 3">Finalizing report...</p>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!isLoading" class="success-container" [@bounceIn]>
          <div class="success-icon-container">
            <div class="success-pulse"></div>
            <div class="success-icon">
              <mat-icon>check_circle</mat-icon>
            </div>
          </div>
          <h5 class="status-title">Report Ready</h5>
          <p class="status-message">Your piezo sensor report has been generated successfully.</p>
          <div class="report-preview">
            <div class="preview-document">
              <div class="preview-header"></div>
              <div class="preview-content">
                <div class="preview-line"></div>
                <div class="preview-line"></div>
                <div class="preview-chart"></div>
                <div class="preview-line short"></div>
                <div class="preview-line"></div>
              </div>
            </div>
          </div>
          <div class="report-actions">
            <button mat-flat-button color="primary" (click)="downloadReport()" class="download-btn"
              [disabled]="isDownloading">
              <div class="button-content">
                <mat-spinner *ngIf="isDownloading" [diameter]="20" class="spinner"></mat-spinner>
                <mat-icon *ngIf="!isDownloading">download</mat-icon>
                <span *ngIf="!isDownloading">Download Report</span>
              </div>
            </button>
            <button mat-stroked-button color="primary" (click)="previewReport()">
              <mat-icon>visibility</mat-icon>
              Preview
            </button>
          </div>
          <div class="report-meta">
            <div class="meta-item">
              <mat-icon>access_time</mat-icon>
              <span>Generated {{ today | date:'medium' }}</span>
            </div>
            <div class="meta-item">
              <mat-icon>insert_drive_file</mat-icon>
              <span>PDF Format • {{ reportSize }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer" *ngIf="!isLoading">
        <button mat-button (click)="closeReportModal()">Close</button>
      </div>
    </div>
  </div>
</div>